import React from 'react';
import Multiselect from 'multiselect-react-dropdown';
import { Input, Checkbox } from '../../../ui';
import { useBuilderEditor } from '../../../../features/builder/BuilderEditorContext';

const RemarksTab = () => {
  const {
    remarkTitle, setRemarkTitle, remarkRequired, setRemarkRequired,
    allowComments, setAllowComments, markUnsaved, isRemarkNeeded,
    choiceoptions, onRemarksOptionSelect,
  } = useBuilderEditor();

  if (!isRemarkNeeded()) {
    return <p className="builder-text-secondary">Remarks are not available for this question type.</p>;
  }

  const selectedRemarks = choiceoptions.filter((x) => x.showRemarks === true);

  return (
    <div className="builder-property-tab">
      <div>
        <label className="builder-label">Include remark for</label>
        <Multiselect
          options={choiceoptions.filter((o) => !o.showOthers)}
          selectedValues={selectedRemarks}
          onSelect={onRemarksOptionSelect}
          onRemove={onRemarksOptionSelect}
          displayValue="name"
        />
      </div>
     
      <Input
        label="Remark Title"
        value={remarkTitle || ''}
        onChange={(e) => { setRemarkTitle(e.target.value); markUnsaved(); }}
      />
      <Checkbox
        label="Remarks required"
        checked={remarkRequired}
        onChange={(e) => { setRemarkRequired(e.target.checked); markUnsaved(); }}
      />
    </div>
  );
};

export default RemarksTab;
